/**
 * Created by evgeny on 14.06.2024
 */

const FamiliesHelper = {
    ShapeCell: [
        { x: 0, y: 0 }
    ],

    calculateShape: function (shape) {
        if (!shape) {
            return;
        }

        const regex = /(\d+)x(\d+)\s?(up)?/;
        const match = shape.match(regex);

        if (!match) {
            return;
        }

        const x = Number(match[1]);
        const y = Number(match[2]);

        const hasUP = match[3] === "up";
        const signX = hasUP ? -1 : 1;
        const signY = hasUP ? 1 : -1;

        shape = [];

        for (let i = 0; i < Math.abs(x); i++) {
            for (let j = 0; j < Math.abs(y); j++) {
                shape.push({ x: i * signX, y: j * signY });
            }
        }

        return shape;
    },

    MultiCellUnitFamily: function (unit, options) {
        options = options || {};

        return {
            type: options.type,
            units: Array.isArray(unit) ? unit : cleverapps.arrayFill(options.total || 1, unit),
            expeditions: options.expeditions,
            images: options.images,
            oneViewForStages: options.oneViewForStages,
            locators: options.locators,
            extraBundles: options.extraBundles
        };
    },

    FurnitureFamily: function (options) {
        const furniture = options.furniture;
        const units = [];

        const stagesAmount = furniture.upgradeType === "fix" ? 2 : 1;

        for (let i = 0; i < stagesAmount; i++) {
            units.push({
                homefixId: options.furniture.name,
                highlight: !options.invisible,
                invisible: options.invisible,
                regionControl: options.region ? {
                    region: options.region,
                    decoratorCode: options.decoratorCode,
                    skin: i === 0 ? options.brokenSkin : options.fixedSkin,
                    brokenSkin: options.brokenSkin
                } : undefined,
                movable: false,
                squeezable: options.squeezable,
                multicell: this.calculateShape(furniture.multicell),
                throwaway: furniture.upgradeType === "throwaway",
                fixable: furniture.upgradeType === "fix",
                untouchable: furniture.untouchable || i === furniture.untouchableStage,
                upgradeAnimation: furniture.upgradeAnimation
            });
        }

        if (options.completeLocation !== undefined) {
            units[units.length - 1].completeLocation = options.completeLocation;
        }

        return {
            type: "furniture",
            furniture,
            units,
            localization: false,
            expeditions: options && options.expeditions
        };
    },

    SoonFamily: function (options) {
        return {
            type: "soon",
            units: [{
                soon: true,
                movable: false
            }],
            expeditions: options.expeditions
        };
    }
};

if (typeof cc === "undefined") {
    module.exports = FamiliesHelper;
}
